import React from 'react';

import classNames from 'classnames/bind';
import style from './Quote.scss';
const ctx = classNames.bind(style);

const Quote = props => (
  <div className={ctx('quote')}>
    <div className={ctx('author')}>
      <div className={ctx('photo')}>
        <img src={props.author.photo} width="100%" height="100%" />
      </div>
      <div className={ctx('description')}>
        <div className={ctx('position')}>
          {props.author.position}
          <a
            href="https://hals-development.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
            target="_blank"
          >
            {props.author.positionLink}
          </a>
        </div>
        <div className={ctx('who-is')}>
          <span className={ctx('full-name')}>{props.author.fullName}</span>
        </div>
      </div>
    </div>
    <div className={ctx('text')}>{props.text}</div>
  </div>
);

export default Quote;

/*
<span className={ctx('nick')}>({props.author.nick})</span>
*/
/*
https://github.com/ctrlplusb/react-sizeme
*/
